import { HttpErrorResponse } from '@angular/common/http';

/**
 * Mapea un error de petición HTTP a la clave i18n del namespace `errors.http.*`.
 *
 * Cubre los códigos documentados en OpenAPI (400/401/403/404/409), los 5xx
 * (→ "Error del sistema") y cualquier otro caso (→ "Error desconocido").
 *
 * El `message` del backend (en inglés, no traducible) NO se usa para el texto
 * mostrado al usuario; se reserva para logging técnico.
 *
 * @param error - Error capturado en un handler `error:` de una suscripción.
 * @returns Clave i18n lista para `TranslateService.instant(...)`.
 */
export function httpErrorKey(error: unknown): string {
  const status = error instanceof HttpErrorResponse ? error.status : undefined;

  switch (status) {
    case 400:
      return 'errors.http.400';
    case 401:
      return 'errors.http.401';
    case 403:
      return 'errors.http.403';
    case 404:
      return 'errors.http.404';
    case 409:
      return 'errors.http.409';
    default:
      if (status && status >= 500) {
        return 'errors.http.500';
      }
      return 'errors.http.unknown';
  }
}
